import * as React from "react";
import { ZCatalogActionCreate } from "src/business/catalog/ZCatalog";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZId } from "src/types";

import { CreateBtnLinkStd } from "./CreateBtnLinkStd";

type PropsCreateActionRenderer = ZCatalogActionCreate & {
  catalogId: ZId;
};

export const CreateActionRenderer: React.FC<PropsCreateActionRenderer> = ({
  catalogId,
  disabled,
}) => (
  <CreateBtnLinkStd
    text="Запись"
    disabled={disabled}
    url={makeUrl(PageUrl.newRecord, { id: catalogId })}
  />
);
